import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import Pagination from "../../../components/Pagination";

const FarmerSeasonForm = (props) => {
  const [filteredFarmers, setFilteredFarmers] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [farmers, setFarmers] = useState([]);
  const [selectedSeasonId, setSelectedSeasonId] = useState("");
  const [selectedFarmers, setSelectedFarmers] = useState([]);

  const [searchVisible, setSearchVisible] = useState({
    name: false,
    no: false,
    lga: false,
    seasonName: false,
  });
  const [filters, setFilters] = useState({
    name: "",
    no: "",
    lga: "",
    seasonName: "",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const { sendRequest: fetchFarmersList } = useHttp();
  const { sendRequest: fetchSeasons } = useHttp();
  const { sendRequest: updateFarmersSeason } = useHttp();

  useEffect(() => {
    fetchFarmersList(
      { url: `/api/getAllFarmersWeb/?orgId=${localStorage.getItem("orgId")}` },
      (res) => {
        if (Array.isArray(res)) {
          setFarmers(res);
          setFilteredFarmers(res);
        }
      }
    );
  }, []);

  useEffect(() => {
    fetchSeasons(
      { url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}` },
      (res) => {
        if (Array.isArray(res)) setSeasons(res);
      }
    );
  }, [fetchSeasons]);

  const handleCheckboxChange = (farmerId) => {
    setSelectedFarmers((prev) =>
      prev.includes(farmerId)
        ? prev.filter((id) => id !== farmerId)
        : [...prev, farmerId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedSeasonId) {
      toast.error("Please select a season!");
      return;
    }

    if (selectedFarmers.length === 0) {
      toast.error("Please select at least one farmer!");
      return;
    }

    updateFarmersSeason(
      {
        url: "/api/updateFarmerSeason/",
        method: "POST",
        body: {
          seasonId: selectedSeasonId,
          farmerIds: selectedFarmers,
          empId: localStorage.getItem("empId"),  // ✅ REQUIRED
        },
      },
      (res) => {
        toast.success(res.message || "Farmers updated successfully!");
        props.addForm(false);
      }
    );
  };

useEffect(() => {
  const name = filters.name.trim().toLowerCase();
  const no = filters.no.trim().toLowerCase();
  const lga = filters.lga.trim().toLowerCase();
  const seasonName = filters.seasonName.trim().toLowerCase();

  const filtered = farmers.filter((f) => {
    const farmerName = (f.farmerName || "").toLowerCase();
    const farmerNo = (f.farmerNo || "").toLowerCase();
    const farmerLga = (f.lga || "").toLowerCase();
    const farmerSeasonName = (f.seasonName || "").toLowerCase();

    const matchName = farmerName.includes(name);
    const matchNo = farmerNo.includes(no);
    const matchLga = farmerLga.includes(lga);
    const matchSeasonName = farmerSeasonName.includes(seasonName);

    return matchName && matchNo && matchLga && matchSeasonName;
  });

    setFilteredFarmers(filtered);
    setCurrentPage(1);
  }, [filters, farmers]);


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFarmers = filteredFarmers.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="card card-default">
            <div
              className="card-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 className="card-title mb-0">Farmer Season Form</h3>
              <button
                type="button"
                className="btn btn-tool"
                onClick={() => props.addForm(false)}
                style={{ fontSize: "1.3rem", marginLeft: "auto" }}
              >
                <i className="fas fa-times" />
              </button>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Season Name</label>
                      <select
                        className="form-control"
                        value={selectedSeasonId}
                        onChange={(e) => setSelectedSeasonId(e.target.value)}
                        required
                      >
                        <option value="">Select Season</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>Select</th>
                        <th>
                          Farmer Name
                          <i
                            className="fas fa-search text-dark ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setSearchVisible((prev) => ({
                                ...prev,
                                name: !prev.name,
                              }))
                            }
                          ></i>
                          {searchVisible.name && (
                            <input
                              type="text"
                              className="form-control mt-1"
                              style={{ width: "80%", margin: "auto" }}
                              placeholder="Search..."
                              value={filters.name}
                              onChange={(e) =>
                                setFilters({ ...filters, name: e.target.value })
                              }
                            />
                          )}
                        </th>
                        <th>
                          Farmer No
                          <i
                            className="fas fa-search text-dark ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setSearchVisible((prev) => ({
                                ...prev,
                                no: !prev.no,
                              }))
                            }
                          ></i>
                          {searchVisible.no && (
                            <input
                              type="text"
                              className="form-control mt-1"
                              style={{ width: "80%", margin: "auto" }}
                              placeholder="Search..."
                              value={filters.no}
                              onChange={(e) =>
                                setFilters({ ...filters, no: e.target.value })
                              }
                            />
                          )}
                        </th>
                        <th>
                          LGA
                          <i
                            className="fas fa-search text-dark ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setSearchVisible((prev) => ({
                                ...prev,
                                lga: !prev.lga,
                              }))
                            }
                          ></i>
                          {searchVisible.lga && (
                            <input
                              type="text"
                              className="form-control mt-1"
                              style={{ width: "80%", margin: "auto" }}
                              placeholder="Search..."
                              value={filters.lga}
                              onChange={(e) =>
                                setFilters({ ...filters, lga: e.target.value })
                              }
                            />
                          )}
                        </th>
                        <th>Season Name
                          <i
                            className="fas fa-search text-dark ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setSearchVisible((prev) => ({
                                ...prev,
                                seasonName: !prev.seasonName,
                              }))
                            }
                          ></i>
                          {searchVisible.seasonName && (
                            <input
                              type="text"
                              className="form-control mt-1"
                              style={{ width: "80%", margin: "auto" }}
                              placeholder="Search..."
                              value={filters.seasonName}
                              onChange={(e) =>
                                setFilters({ ...filters, seasonName: e.target.value })
                              }
                            />
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentFarmers.length > 0 ? (
                        currentFarmers.map((x) => (
                          <tr key={x.farmerId}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedFarmers.includes(x.farmerId)}
                                onChange={() =>
                                  handleCheckboxChange(x.farmerId)
                                }
                              />
                            </td>
                            <td>{x.farmerName}</td>
                            <td>{x.farmerNo}</td>
                            <td>{x.lga}</td>
                            <td>{x.seasonName || ""}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No farmers found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="card-footer clearfix">
                  <Pagination
                    totalItems={filteredFarmers.length}
                    itemsPerPage={itemsPerPage}
                    onPageChange={paginate}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
                <div className="mt-3 text-right">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FarmerSeasonForm;
